import React from 'react';

import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import {Heading, Text} from '@edume/magnificent';

import styles from './styles.module.scss';

function UserDetailCard({title, completionDate, imageUrl, icon}) {
  return (
    <div styleName='user-detail-card'>
      {imageUrl && (
        <div styleName='user-detail-card-img'>
          <img src={imageUrl} width='64' alt='' />
        </div>
      )}
      {icon && (
        <div styleName='user-detail-card-img icon'>
          <img
            width={50}
            src={`https://edume-res.cloudinary.com/image/upload/course_icons/transparent/${icon}.png`}
            alt=''
          />
        </div>
      )}
      <div>
        {completionDate && (
          <Text
            colour='textSecondary'
            inline='false'
            lineHeight='tight'
            size='s'
            textTransform='none'
            weight='regular'
          >
            Completed <strong>{completionDate}</strong>
          </Text>
        )}
        <Heading
          as='h2'
          colour='textPrimary'
          size='hamster'
          textTransform='none'
          weight='semiBold'
        >
          {title}
        </Heading>
      </div>
    </div>
  );
}

UserDetailCard.propTypes = {
  imageUrl: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  completionDate: PropTypes.string,
};

export default CSSModules(UserDetailCard, styles, {allowMultiple: true});
